import { faArrowUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AssignmentTypeEnum, AssignmentViewModel } from 'api/model';
import styled from 'styled-components';

const Center = styled.div`
  display: flex;
  justify-content: center;
`;
const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

export const goToCase = (caseId: number) => {
  window.open(`/sok/${caseId}`, caseId.toString());
};

export const getAssignmentPriorityIcon = (prio: number): React.ReactNode => {
  switch (prio) {
    case 1:
      return (
        <IconWrapper>
          <FontAwesomeIcon color="red" icon={faArrowUp} />
        </IconWrapper>
      );

    default:
      return <Center>-</Center>;
  }
};

export const getAssignmentPriority = (assignment: AssignmentViewModel) => {
  // assignmenttype  Normal or WithTest is Prio 1
  // assignmenttype FurtherTransport is Prio 2

  if (
    (
      [
        AssignmentTypeEnum.Normal,
        AssignmentTypeEnum.WithTest,
      ] as AssignmentTypeEnum[]
    ).includes(assignment.assignment.assignmentTypeID)
  ) {
    return 1;
  }

  if (
    assignment.assignment.assignmentTypeID ===
    AssignmentTypeEnum.FurtherTransport
  ) {
    return 2;
  }

  return 3;
};
export default goToCase;
